<mat-dialog-content>
  <div class="close mat-elevation-z3" (click)="dialogRef.close()"><i class="fa fa-times "></i></div>

  @if (data.componentsNumber>0) {
    <div>
      @for (form of formComponentes; track form) {
        <div>
          <div class='default-row'>
            <div class='row-item'>
              <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input [(ngModel)]="form.name" autocomplete="off" type="text" matInput #nombre maxlength="255"
                  placeholder="Nombre" required>
                <mat-hint>{{nombre.value.length}}/255</mat-hint>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>
            <div class='row-item'>
              <mat-form-field>
                <mat-label>Especificaciones</mat-label>
                <input [(ngModel)]="form.specifications" autocomplete="off" type="text" matInput #especificaciones
                  maxlength="255" placeholder="Especificaciones" required>
                <mat-hint>{{especificaciones.value.length}}/255</mat-hint>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="row-item">
            <file-input [params]='fileInputComponente' (fileSave)='fileSaveComponente($event, form.index)'></file-input>
          </div> -->
        </div>
      </div>
    }
    <button color="primary" class="button-save mat-elevation-z5 " mat-raised-button
    (click)="saveComponente('addComponentes')">Guardar</button>
  </div>
}

<div>
  @if (data.action =="addComponente") {
    <h2 style="text-align: center;">Agregar componente</h2>
  }
  @if (data.action =="editComponente") {
    <h2 style="text-align: center;">Editar componente</h2>
  }

  @if (data.action =="addComponente" || data.action =="editComponente") {
    <form [formGroup]="componentsForm"
      (ngSubmit)="componentsForm.valid?saveComponente(componentsForm.value):errorMessage()">
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input autocomplete="off" type="text" formControlName='name' matInput placeholder="Nombre" required>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Especificaciones</mat-label>
        <input autocomplete="off" type="text" formControlName='specifications' matInput placeholder="Especificaciones">
      </mat-form-field>
      <!-- <div class="row-item">
      <file-input [params]='fileInputComponente' (fileSave)='fileSaveComponente($event, "fileTable")'></file-input>
    </div> -->
    <button color="primary" class="button-save mat-elevation-z5" mat-raised-button type="submit">Guardar</button>
  </form>
}

</div>

</mat-dialog-content>